import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthorizedInvestorService } from '@common/services/authorized-investor.service';

export const authorizedInvestorGuard: CanActivateFn = () => {
  const _AuthorizedInvestorService = inject(AuthorizedInvestorService);

  return _AuthorizedInvestorService.checkAuthorizedInvestorNavigation();
};
